import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import EnhancedChatDashboard from './components/EnhancedChatDashboard';
import SupportDashboard from './components/SupportDashboard';
import './testAPI'; // This will run the API test

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        
        <main className="app-main">
          <Routes>
            <Route path="/" element={<EnhancedChatDashboard />} />
            <Route path="/support" element={<SupportDashboard />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
